/**
 * Created by JasonChou on 17/6/14.
 */
import React, {Component} from 'react'
import {merge} from '../../utils/uiUtils'

export default class Vertical extends Component {
    render() {
        const {style, vc, hc, ...other} = this.props;


        const newStyle = {};

        if (vc) {
            newStyle.justifyContent = 'center'
        }

        if (hc) {
            newStyle.alignItems = 'center'
        }

        return <div style={merge(newStyle, style)} className="v" {...other}/>
    }
}




// WEBPACK FOOTER //
// ./src/components/layouts/Vertical.js